import { useRef } from "react"
import { useAuth } from "../../context/AuthContext";
import AdminQuery from "./adminQuery";
import NotFound from "../../NotFound";

export default function Admin({data}){
    const displayRef = useRef(null);
    const{ roles, email, token } = useAuth();

    if(roles !== null){
        if(!roles.includes("cdlisAdmin")){
            return(<NotFound />)
        }
    }
   
  
    return (
        <div>
            <div ref={displayRef}>
                <AdminQuery displayRef={displayRef} em={email} token={token} />
            </div>
        </div>
    )
    
}